import { render, staticRenderFns } from "./Unpublished.vue?vue&type=template&id=bbf66c32&scoped=true"
import script from "./Unpublished.vue?vue&type=script&lang=js"
export * from "./Unpublished.vue?vue&type=script&lang=js"
import style0 from "./Unpublished.vue?vue&type=style&index=0&id=bbf66c32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf66c32",
  null
  
)

export default component.exports